import {
  DEFAULT_TRANSCRIPTION_LANGUAGE,
  TRANSCRIPTION_LANGUAGES,
  __TEST__
} from '@mote/helpers/constants'
import window from '@mote/helpers/injectChromeObject'
import { noLog as log } from '../shared/Utils'

const _MANAGED_KEYS = {
  extensionEnabled: true,
  dateInstalled: 0,
  legals: 0,
  lastTranslationLanguage: '',
  canTranscribe: true,
  transcriptionOptOut: undefined,
  transcriptionLanguage: DEFAULT_TRANSCRIPTION_LANGUAGE,
  recommendedTranscriptionLocale: '',
  userSelectedTranscriptionLocale: '',
  seenTranscriptionLanguages: '',
  lastAppUpgradeVersionMessageSeen: '',
  needsOnboarding: true,
  useRapinoeUI: false
}

var _CACHE = Object.assign({}, _MANAGED_KEYS)
var _IS_INITING = true
var _LISTENERS = []

_init()

function _init() {
  if (__TEST__) return
  _IS_INITING = true
  _read()
  window?.chrome?.storage?.onChanged?.addListener((changes, areaName) => {
    log('Received a storage area change', changes, areaName)
    if (
      !_IS_INITING &&
      areaName === 'local' &&
      changes &&
      Object.keys(changes).length
    ) {
      log('actionable change')
      _read()
    }
  })
}

function _read() {
  if (__TEST__) return
  log('Reading changes', Object.keys(_MANAGED_KEYS))
  window?.chrome?.storage?.local?.get(Object.keys(_MANAGED_KEYS), result => {
    log('get read completed: ', result)
    for (const key of Object.keys(result)) {
      log(
        'Assigning:' +
          key +
          '--> ' +
          result[key] +
          ' - was previously:' +
          _CACHE[key]
      )
      _CACHE[key] = result[key]
    }
    if (
      !_IS_INITING &&
      _CACHE.canTranscribe === false &&
      _CACHE.transcriptionOptOut === false
    ) {
      SetKey('transcriptionOptOut', true)
    }
    if (_IS_INITING) {
      _write()
    }
    if (_LISTENERS.length) {
      for (const f of _LISTENERS) {
        f(_CACHE)
      }
    }
  })
}

function _write() {
  window?.chrome?.storage?.local?.set(_CACHE, () => {
    log('Wrote out cache: ', _CACHE)
    _IS_INITING = false
  })
}

function GetKey(key) {
  if (key in _MANAGED_KEYS) {
    return _CACHE[key]
  } else {
    console.error('Tried to look up: ' + key)
    return ''
  }
}

function SetKey(key, value) {
  if (key in _MANAGED_KEYS) {
    const o = {}
    o[key] = value
    _CACHE[key] = value
    window?.chrome?.storage?.local?.set(o)
  } else {
    console.error('Tried to set: ' + key + ' with value: ' + value)
  }
  return value
}

function IsEnabled() {
  return GetKey('extensionEnabled')
}

function HasOptedOutOfTranscription() {
  const optOut = GetKey('transcriptionOptOut')
  const canTranscribe = GetKey('canTranscribe')
  return Boolean(optOut) || !canTranscribe
}

function GetTranscriptionLanguage() {
  const language =
    GetKey('userSelectedTranscriptionLocale') ||
    GetKey('recommendedTranscriptionLocale') ||
    GetKey('transcriptionLanguage')
  return _findMemberLanguage(language)[0]
}

function SetTranscriptionLanguage(language) {
  SetKey('userSelectedTranscriptionLocale', language)
  SetKey('transcriptionLanguage', language)
}

function _findMemberLanguage(language) {
  if (!language) {
    return TRANSCRIPTION_LANGUAGES[0]
  }
  for (const pair of TRANSCRIPTION_LANGUAGES) {
    if (language === pair[0]) {
      return pair
    }
  }
  return TRANSCRIPTION_LANGUAGES[0]
}

export {
  GetKey,
  SetKey,
  IsEnabled,
  GetTranscriptionLanguage,
  SetTranscriptionLanguage,
  HasOptedOutOfTranscription
}
